import { Company, Lead } from 'utils/types';

import {
  leadContactProfileDetailsMapper,
  companyContactProfileDetailsMapper,
} from './contactDetailsMapper';

const contactDetails = ({
  data: {
    firstName,
    lastName,
    fullName,
    accountUserId,
    companyId,
    photoUrl,
    ...rest
  },
}: {
  data: Lead;
}) => ({
  data: {
    ...rest,
    photoUrl,
    firstName,
    lastName,
    fullName,
    companyId:
      typeof companyId === 'string'
        ? companyId
        : {
            ...companyId,
          },
    accountUserId,
    contactDetails: leadContactProfileDetailsMapper({
      ...rest,
    }),
  },
});

const companyContactDetails = ({
  data: { photoUrl, ...rest },
}: {
  data: Company;
}) => ({
  data: {
    ...rest,
    photoUrl,
    contactDetails: companyContactProfileDetailsMapper(rest),
  },
});

export default { contactDetails, companyContactDetails };
